export const promiseAllSettled = async (aPayload: any[]) => {
  const re = await Promise.allSettled(aPayload.map((func) => func()));
  const value = promiseStatus(re);

  return value;
};

export const promiseStatus = (re: any[]) => {
  const value = [];
  for (const iter of re) {
    if (iter.status === 'fulfilled') {
      value.push(iter.value);
    } else {
      console.log('Rejected:', iter.reason.message); // 실패한 경우
    }
  }
  return value;
};
